import { HOME_PORT_TITLE_VARIANT, HOME_PORT_TYPE } from 'types'

const INVALID_HOME_PORT_TYPE_TITLE = 'Invalid Homeport Type'

const { LOCATE, SEARCH, SUMMARY } = HOME_PORT_TITLE_VARIANT

const HOME_PORT_TITLES = {
  [HOME_PORT_TYPE.MARINA]: {
    [SEARCH]: 'Search Marina Name or Address',
    [LOCATE]: 'Locate Marina',
    [SUMMARY]: 'Name & Address of Marina:',
  },
  [HOME_PORT_TYPE.TRAILER]: {
    [SEARCH]: 'Name of Trailer Ramp You Use a Majority of the Time',
    [LOCATE]: 'Locate Trailer Ramp',
    [SUMMARY]: 'Trailer Ramp Used Most Often:',
  },
  [HOME_PORT_TYPE.HOME_DOCK]: {
    [SEARCH]: 'Address of Home Dock',
    [LOCATE]: 'Locate Home Dock Address',
    [SUMMARY]: 'Address of Home Dock:',
  },
  [HOME_PORT_TYPE.MOORING]: {
    [SEARCH]: 'Search Mooring Body of Water or Facility',
    [LOCATE]: 'Locate Mooring',
    [SUMMARY]: 'Body of Water/Facility:',
  },
  [HOME_PORT_TYPE.OTHER]: {
    [SEARCH]: 'Search for Name of Marina, Facility, or Body of Water',
    [LOCATE]: 'Locate Home Port',
    [SUMMARY]: 'Name & Address of Where Boat is Kept:',
  },
}

export default function titleForHomePortByType(homePortType, variant) {
  return HOME_PORT_TITLES[homePortType]?.[variant] ?? INVALID_HOME_PORT_TYPE_TITLE
}
